module.exports = __webpack_public_path__ + "img/aiot_logo2.1b637001.png";